<template>
  <div class="content_section registration">
                <div class="rep_info">
                  <h2>Registration Type</h2>
                  <form class="" action="index.html" method="post">
                    <div class="input_box">
                      <label for="">Registration Type <span class="red">*</span></label>
                      <div class="inputs">
                        <select class="" name="">
                          <option value="">Select</option>
                          <option value="">Select One</option>
                          <option value="">Select Two</option>
                          <option value="">Select Three</option>
                          <option value="">Select Four</option>
                        </select>
                        <p class="error_message">This is a required field</p>
                      </div>
                    </div>
                    <div class="buttonbox">
                      <button @click="navigatePrevious" class="previous" type="button" name="button">Previous</button>
                      <button class="save" type="button" name="button">Save</button>
                      <button  @click="saveAndContinue" class="next" type="button" name="button">Next</button>
                    </div>
                  </form>
                </div>
              </div>
</template>
<script>

export default {
    name: "RegistrationType",
    props: {
      navdata: {
        type: Array
      }
    },
    methods: {
      saveAndContinue() {
        //Update APIs
        //Navigate to next page
        this.$emit('comEnvNavigation', this.$route.name);
      },
      navigatePrevious() {
        //Update APIs
        //Navigate to next page
        this.$emit('comEnvNavigationBack', this.$route.name);
      },
    }
  }
</script>
